import { render, staticRenderFns } from "./CGVConsult.vue?vue&type=template&id=7ffb804f&scoped=true"
import script from "./CGVConsult.vue?vue&type=script&lang=js"
export * from "./CGVConsult.vue?vue&type=script&lang=js"
import style0 from "./CGVConsult.vue?vue&type=style&index=0&id=7ffb804f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffb804f",
  null
  
)

export default component.exports